import { checkLoginStatus } from '$lib/appstate.svelte';
import type { ClientInit } from '@sveltejs/kit';

export const init: ClientInit = async () => {
	checkLoginStatus();
};
